    <lib-data-table tableType="dataTable" tableId=userlist [tableConfig]="tableConfig" [data]="tableData" (optionsClick)="handleOptionClick($event)" [clickableDataTypes]="dataTypes"
    [customTemplates]="{'status': status}">
    </lib-data-table>
    <ng-template #status let-rowData="rowData" let-index="index">
      <td (click)="handleRowClick(rowData,index)">
        <span class="font-weight-bold" [ngClass]="rowData[index]?.values[0] === 'Active' ? 'text-success':'text-danger'" >{{rowData[index]?.values[0]}}</span>
      </td>
    </ng-template>
